export default "__VITE_ASSET__698e8200__"